import { Component } from '@angular/core';

/* eslint-disable @typescript-eslint/no-empty-function */
@Component({
  selector: 'app-next-prev',
  standalone: true,
  templateUrl: './next-prev.component.html',
  styleUrls: ['./next-prev.component.scss'],
})
export class NextPrevComponent {
  currentStep: number = 0;
  goNext() {}

  goPrev() {}
}

// TODO: WIDGET NOT IN USE YET
